import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import DateFormatter from 'common/utils/DateFormatter';
import Icon from 'common/components/elements/icons';
import './style.scss'
import ImgGallery from '../../img-gallery';
import cx from 'classnames'
import {
   MediaLableItem,
} from 'common/components/modules/media';

const StoreImgCard = ({
   src,
   price,
   status,
   statusIcon,
   statusName,
   statusDate,
   isDetails,
   isMobile,
   date,
   showComingSoon,
   newImgArray,
   data,
   hidePrice,
   showBundleIcon,
   endsDate,
   isSoldOut,
   comment,
   isInsideModal,
   isReorderMode,
}) => {

   const [hideTimeLeft, setHideTimeLeft] = useState(false)
   const images = newImgArray?.map(item => ({ original: item.path }));

   return (
      <div
         className='w-full relative h-full card-height overflow-hidden bg-cover rounded-t-lg bg-center select-none'
         id='store-item-div'
         role='presentation'
         onMouseEnter={ () => {
            setHideTimeLeft(true)
         } }
         onMouseLeave={ () => {
            setHideTimeLeft(false)
         } }
      >
         <div className='h-full w-full cursor-pointer relative'>
            <div className='aspect-ratio-padding' />
            <div className='absolute top-0 left-0 w-full h-full store-top-content-height z-[1] group'>
               <div className={ `text-major-dark w-full h-full overflow-hidden rounded-t-lg` }>
                  <div
                     style={ {
                        backgroundImage: `url(${ src })`,
                        filter: 'blur(24px)',
                        zIndex: '-1',
                     } }
                     className=' bg-cover bg-center w-full h-full'
                  />
                  <div
                     className={ `w-full h-full absolute top-0 left-0 bg-contain bg-center bg-no-repeat ${ isDetails ? '' : 'rounded-t-lg' }` }

                  >
                     {
                        !newImgArray && <img src={ src } alt='' />
                     }
                     {
                        newImgArray &&
                           <ImgGallery
                              images={ images }
                              showFullScreen={ false }
                              classNameIconDiv='next-icon-classes mms-media-button-wrapper-bg'
                              showBullets
                              isPreventFullScreenAction
                           />
                     }
                  </div>
                  <StoreCardContent
                     status={ status }
                     statusIcon={ statusIcon }
                     statusName={ statusName }
                     statusDate={ statusDate }
                     price={ price }
                     newImgArray={ newImgArray }
                     data={ data }
                     hidePrice={ hidePrice }
                     showBundleIcon={ showBundleIcon }
                     endsDate={ endsDate }
                     isSoldOut={ isSoldOut }
                     comment={ comment }
                     hideTimeLeft={ hideTimeLeft }
                     isDetails={ isDetails }
                     isInsideModal={ isInsideModal }
                     isReorderMode={ isReorderMode }
                  />
               </div>
               {
                  !!showComingSoon && (
                     <>
                        <div
                           className={ `absolute w-full text-major-dark bg-no-repeat bg-cover inset-0 flex flex-col items-center justify-center ${ isDetails && isMobile ? '' : 'rounded-label' }` }>
                           <div className='flex flex-col justify-center items-center z-20'>
                              <span className='font-bold coming-soon-text'>Coming soon</span>
                              <span className='leading-tight mt-2 text-center'>{!!date ? DateFormatter.getDateLeft(date) : ''}</span>
                           </div>
                        </div>
                     </>
                  )
               }
               {
                  status === 'unpublish' && !showComingSoon && !isDetails && (
                     <>
                        <div
                           className={ `non-published-bg bg-major-60 dark:bg-grey-hover-dark-60 rounded-t-lg absolute top-0 z-30 left-0 w-full h-full flex flex-col items-center justify-center gap-1 group-hover:hidden` }>
                           <div className='flex flex-col justify-center items-center z-20'>
                              <Icon
                                 name={ 'unpublish' }
                                 color='major-dark'
                                 size='2xl'
                              />
                              <span className='mt-1 text-major-dark text-lg leading-7 font-semibold select-none'>Unpublished</span>
                           </div>
                        </div>
                     </>
                  )
               }
            </div>
         </div>
      </div>
   );
};

const StoreCardContent = ({
   status,
   statusIcon,
   statusName,
   statusDate,
   price,
   data,
   hidePrice,
   showBundleIcon,
   endsDate,
   isSoldOut,
   comment,
   hideTimeLeft,
   isDetails,
   isInsideModal,
   isReorderMode,
}) => {

   let calculateTimeLeft = () => DateFormatter.calculateTimeLeft(endsDate)
   const [timeLeft, setTimeLeft] = useState(endsDate ? calculateTimeLeft() : null)

   useEffect(() => {
      let timer
      if(timeLeft !== null) {
         timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
         }, 1000);
      }

      return () => clearInterval(timer);
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [timeLeft]);
   const isHasDuration = () => {
      return 'scheduled' !== status && Boolean(endsDate);
   }
   return (
      <>
         {
            (status === 'scheduled' || !!timeLeft || isSoldOut) && (
               <div
                  role='presentation'
                  className={ `non-published-bg bg-major-60 dark:bg-grey-hover-dark-60 rounded-t-lg absolute top-0 z-30 left-0 w-full h-full flex flex-col items-center justify-center gap-1` }
                  style={ {
                     visibility: hideTimeLeft ? 'hidden' : '',
                  } }
               >
                  <Icon
                     name={ isHasDuration() ? 'clock' : statusIcon }
                     color='major-dark'
                     size='2xl'
                  />
                  <span className='mt-px text-major-dark text-xl leading-4 font-medium select-none'>
                     { isHasDuration() ? 'Unpublishes in' : statusName }
                  </span>
                  <span className=' text-major-dark block mt-1 select-none text-center'>
                     {
                        isHasDuration() ?
                           timeLeft
                           :
                           <>
                              {
                                 !isSoldOut &&
                                 <>
                                    {DateFormatter.convertToUserTz(statusDate, 'MMM DD, YYYY hh:mm A')} ({DateFormatter.getZoonFullName()})
                                 </>
                              }
                           </>
                     }
                  </span>
                  {
                     comment &&
                     <p className='text-sm text-center px-4'>{comment}</p>
                  }
               </div>
            )
         }
         {/* <div
            className={ cx({
               'h-9 flex absolute top-0 price-section': true,
               'right-0': isInsideModal,
               'left-0': !isInsideModal,
            }) }
         > */}
         {
            data.product_type === 'attachment_item' && !isDetails &&
            <div
               className={ cx({
                  'm-2 absolute top-0 left-0': true,
               }) }
            >
               <MediaLableItem
                  iconName={ data?.attachment_type === 'rar' ? 'zip' : data?.attachment_type }
                  tooltipContent={ `Downloadable ${ data?.attachment_type !== 'audio' ? data?.attachment_type === 'image' ? 'Image' : `${ data?.attachment_type?.toUpperCase() } file` : 'Audio file' }` }
               />
            </div>
         }
         {
            !isReorderMode && !hidePrice && price &&
               <div
                  className='absolute top-0 right-0 m-2'
               >
                  <MediaLableItem
                     text={ price }
                  />
               </div>
         }
         {
            data?.product_type === 'content_bundle_item' && showBundleIcon &&

            <div
               className={ cx({
                  'm-2 absolute top-0 left-0': true,
               }) }
            >
               <MediaLableItem
                  iconName='bundle'
                  text='Bundle'
               />

            </div>
         }
         {/* </div> */}
      </>
   );
};

StoreCardContent.propTypes = {
   price: PropTypes.string,
   status: PropTypes.string,
   statusIcon: PropTypes.string,
   statusName: PropTypes.string,
   statusDate: PropTypes.string,
   data: PropTypes.object,
   hidePrice: PropTypes.bool,
   showBundleIcon: PropTypes.bool,
   endsDate: PropTypes.string,
   isSoldOut: PropTypes.bool,
   comment: PropTypes.string,
   hideTimeLeft: PropTypes.bool,
   isDetails: PropTypes.bool,
   isInsideModal: PropTypes.bool,
   isReorderMode: PropTypes.bool,
};


StoreImgCard.propTypes = {
   src: PropTypes.string,
   price: PropTypes.string,
   status: PropTypes.string,
   statusIcon: PropTypes.string,
   statusName: PropTypes.string,
   statusDate: PropTypes.string,
   isDetails: PropTypes.bool,
   isMobile: PropTypes.bool,
   date: PropTypes.string,
   showComingSoon: PropTypes.bool,
   newImgArray: PropTypes.array,
   data: PropTypes.object,
   hidePrice: PropTypes.bool,
   showBundleIcon: PropTypes.bool,
   endsDate: PropTypes.string,
   isSoldOut: PropTypes.bool,
   comment: PropTypes.string,
   isInsideModal: PropTypes.bool,
   isReorderMode: PropTypes.bool,
};

StoreImgCard.defaultProps = {
   className: '',
   status: '',
   statusIcon: '',
   statusName: '',
   statusDate: '',
   isDetails: true,
   isMobile: false,
   hidePrice: false,
   showBundleIcon: true,
   endsDate: '',
   isSoldOut: false,
   comment: '',
}

export default StoreImgCard;
